






























import Vue from "vue";
import { isQaEnvironment } from "@/utils/qaEnvironment/qaEnvironment";

export default Vue.extend({
  name: "ThemeSelectInNavToggle",
  computed: {
    isQa(): boolean {
      return isQaEnvironment();
    },
    isDarkMode(): boolean {
      return this.$store.getters.darkMode;
    },
    isThemeSelectShown(): boolean {
      return this.$store.getters.showThemeSelectInNav;
    },
  },
  methods: {
    toggleThemeSelect(): void {
      this.$store.dispatch("toggleShowThemeSelectInNav");
    },
  },
});
